import API from "./API";

export default class SubFamilia extends API
{
    static async all() {
        return this.get("api/admin/sub-familias/list");
    }
}